import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Button, Link as MuiLink } from "@mui/material";
import { DataCardShell } from "../../../../components/responsive";
import {
  closureRetreatTitle,
  formatClosureDateRange,
  isUpcomingClosure,
} from "../closureDisplay";
import { ClosureStatusButtons } from "../ClosureStatusButtons";

export function ClosureRetreatCard({
  row,
  onSendEmail,
}: {
  row: any;
  onSendEmail: (row: any) => void;
}) {
  const displayDate = formatClosureDateRange(row.dateFrom, row.dateTo);

  return (
    <DataCardShell
      highlight={isUpcomingClosure(row)}
      title={
        <MuiLink
          href={`/retreatRoster?retreatId=${row.id}`}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: "#1265c4", fontWeight: 800, textDecoration: "underline" }}
        >
          {closureRetreatTitle(row) || "Untitled retreat"}
        </MuiLink>
      }
      subtitle={[row.id ? `Retreat ID ${row.id}` : null, displayDate || null]
        .filter(Boolean)
        .join(" · ")}
      fields={[
        {
          label: "Confirmations",
          value: <ClosureStatusButtons row={row} />,
        },
      ]}
      primaryAction={
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 400 }}
          overlay={
            <Tooltip id="button-tooltip">
              Send Email to Lead Couples and Steering Committee
            </Tooltip>
          }
        >
          <span>
            <Button
              size="small"
              variant="contained"
              onClick={() => onSendEmail(row)}
              startIcon={
                <i className="mdi mdi-email-outline" style={{ fontSize: 18 }} />
              }
            >
              Send Email
            </Button>
          </span>
        </OverlayTrigger>
      }
    />
  );
}
